import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { SITE } from "@/data/content";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Não foi possível entrar.");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block bg-rose-800 relative overflow-hidden grain">
        <div className="absolute inset-0 grid place-items-center p-16">
          <div>
            <p className="font-display text-5xl text-white leading-tight">
              {SITE.name}<span className="text-rose-300">.</span>
            </p>
            <p className="text-rose-100 mt-4 max-w-xs">Área reservada para a gestão das suas marcações.</p>
          </div>
        </div>
      </div>

      <div className="grid place-items-center px-6 py-16 bg-white">
        <div className="w-full max-w-sm">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-stone-500 hover:text-stone-900">
            <ArrowLeft className="w-4 h-4" /> Voltar ao site
          </Link>
          <h1 className="font-display text-4xl text-stone-900 mt-8">Entrar</h1>
          <p className="text-stone-500 text-sm mt-2">Aceda ao painel de marcações.</p>

          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" data-testid="login-email" value={email}
                onChange={(e) => setEmail(e.target.value)} className="mt-2" required />
            </div>
            <div>
              <Label htmlFor="password">Palavra-passe</Label>
              <Input id="password" type="password" data-testid="login-password" value={password}
                onChange={(e) => setPassword(e.target.value)} className="mt-2" required />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="login-submit"
              className="btn-rose w-full inline-flex items-center justify-center gap-2 rounded-full bg-rose-800 text-white py-3.5 text-sm disabled:opacity-50">
              {loading && <Loader2 className="w-4 h-4 animate-spin" />} Entrar
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
